//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { IOpChangeState, IReferenceType, IJsonSerializable, IOpDynamic, IOpObject, IOpData } from '../util/interfaces'
import { OpDataList } from '../util'
import { OpDataTypeGroupData } from '../custom/op-data-type-group-data'
import { OpDataTypeInGroup } from './op-data-type-in-group'

export class OpDataTypeGroup implements IReferenceType, IOpChangeState, IJsonSerializable, IOpDynamic, IOpObject {
    public idDataTypeGroup: number
    public idDataTypeGroupType: number
    public idParentGroup: number
    public idReferenceType: number
    public referenceValue: any
    public name: string

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDataTypeGroup
    }
    public getReferenceKey(): number {
        return this.idDataTypeGroup
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    //#region IOpObject Implementation

    public get idObject(): any {
        return this.idDataTypeGroup
    }
    public set idObject(idObject: any) {
        this.idDataTypeGroup = idObject
    }

    public dataList: OpDataList<OpDataTypeGroupData> = new OpDataList<OpDataTypeGroupData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string;

    //#endregion

    public currentDataTypesInGroup: OpDataTypeInGroup[]


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {

            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {

                this.idDataTypeGroup = opObj.I
                this.idDataTypeGroupType = opObj.ID
                this.idParentGroup = opObj.IP
                this.idReferenceType = opObj.IR
                this.referenceValue = opObj.R
                this.name = opObj.N
                this.dynamicValues = opObj.DV
                this.opState = opObj.O

                if (_.size(opObj.DG) > 0) {
                    this.currentDataTypesInGroup = _.map(opObj.DG, (dtig: any) => new OpDataTypeInGroup(dtig))
                } else {
                    this.currentDataTypesInGroup = []
                }

                if (_.size(opObj.DL) > 0) {
                    this.dataList.push(..._.map(opObj.DL, (data: any) => new OpDataTypeGroupData(data)))
                }
            } else {
                if (_.size(opObj.CurrentDataTypesInGroup) > 0) {
                    this.currentDataTypesInGroup = _.map(opObj.CurrentDataTypesInGroup, (dtig: any) => new OpDataTypeInGroup(dtig))
                } else {
                    this.currentDataTypesInGroup = []
                }

                if (_.size(opObj.DataList) > 0) {
                    this.dataList.push(...opObj.DataList.map(data => new OpDataTypeGroupData(data)))
                }

                this.idDataTypeGroup = opObj.ID_DATA_TYPE_GROUP
                this.idDataTypeGroupType = opObj.ID_DATA_TYPE_GROUP_TYPE
                this.idParentGroup = opObj.ID_PARENT_GROUP
                this.name = opObj.NAME
                this.opState = opObj.OpState
                this.dynamicValues = opObj.dynamicValues

                this.idReferenceType = (opObj.ID_REFERENCE_TYPE != null) ? opObj.ID_REFERENCE_TYPE : this.dataList.getValue(Enums.DataType.HELPER_ID_REFERENCE_TYPE)
                this.referenceValue = (opObj.REFERENCE_VALUE != null) ? opObj.REFERENCE_VALUE : this.dataList.getValue(Enums.DataType.HELPER_REFERENCE_VALUE)
            }
        }
    }

    public toJSON(compressed: boolean = false): any {

        if (compressed) {
            return {

                I: this.idDataTypeGroup,
                ID: this.idDataTypeGroupType,
                IP: this.idParentGroup,
                IR: this.idReferenceType,
                R: this.referenceValue,
                N: this.name,
                DV: this.dynamicValues,
                O: this.opState,
                DG: _.size(this.currentDataTypesInGroup) > 0 ? _.map(this.currentDataTypesInGroup, (dtig: OpDataTypeInGroup) => dtig.toJSON(true)) : null,
                DL: _.size(this.dataList) > 0 ? this.dataList : null,

                __IC: 1

            }
        } else {
            return {
                ID_DATA_TYPE_GROUP: this.idDataTypeGroup,
                ID_DATA_TYPE_GROUP_TYPE: this.idDataTypeGroupType,
                ID_PARENT_GROUP: this.idParentGroup,
                ID_REFERENCE_TYPE: this.idReferenceType,
                REFERENCE_VALUE: this.referenceValue,
                NAME: this.name,
                OpState: this.opState,
                CurrentDataTypesInGroup: _.size(this.currentDataTypesInGroup) > 0 ? _.map(this.currentDataTypesInGroup, (dtig: OpDataTypeInGroup) => dtig.toJSON()) : null,
                DataList: _.size(this.dataList) ? _.map(this.dataList.toArray(), (data: OpDataTypeGroupData) => data.toJSON()) : null
            }
        }
    }

    public toString() {
        return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDataTypeGroup[]): JQueryPromise<OpDataTypeGroup[]> {
        var defered = $.Deferred<OpDataTypeGroup[]>()
        if (dataProvider && list && list.length > 0) {
            defered.resolve(list)
        } else {
            defered.resolve(list)
        }
        return defered.promise()
    }

    //#region fromIOpObject

    public static fromIOpObject(object: IOpObject): OpDataTypeGroup {
        const newObject: OpDataTypeGroup = new OpDataTypeGroup(null)

        newObject.idDataTypeGroup = object.idObject
        newObject.opState = object.opState
        newObject.dataList.push(...object.dataList.toArray().map((data: IOpData) => OpDataTypeGroupData.fromIOpData(data)))

        return newObject
    }

    //#endregion
}